//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.VehicleDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[0,"APillarFeature",1,"Features.VehicleDesign.HeadImpactAPillar",0],[0,"ActiveZone",1,0],[0,"ApproachAngle",1,0],[0,"BPillarFeature",1,"Features.VehicleDesign.HeadImpactBPillar",0],[1,"COGFrontXOffset",0,"Expression",0],[1,"COGFrontZOffset",0,"Expression",0],[1,"COGRearXOffset",0,"Expression",0],[1,"COGRearZOffset",0,"Expression",0],[0,"Calculation",1,0],[0,"CreateFMH",1,0],[0,"FrontHeaderFeature",1,"Features.VehicleDesign.HeadImpactFrontHeader",0],[0,"Loading",1,0],[1,"MaxValueExp",0,"Expression",0],[1,"MinValueExp",0,"Expression",0],[0,"RPillarFeature",1,"Features.VehicleDesign.HeadImpactRPillar",0],[0,"RearHeaderFeature",1,"Features.VehicleDesign.HeadImpactRearHeader",0],[0,"RequirementsControl",1,0],[1,"SelectPanel",0,"ScCollector",0],[1,"SelectTrim",0,"ScCollector",0],[0,"SideRailFeature",1,"Features.VehicleDesign.HeadImpactSideRail",0],[0,"Standard",1,0],[0,"UpperRoofFeature",1,"Features.VehicleDesign.HeadImpactUpperRoof",0],[0,"VisualizeZone",1,0],[1,"ZoneDistance",0,"Expression",0]],[[["feature"],"AddAdditionalPillarFeature",{},1,0],[["feature"],"AddAdditionalRailFeature",{},1,0],[[],"GenerateFHM",{},0,0],[[],"GenerateHeatMap",{},0,0]],[]];
SPLM.Features.VehicleDesign.HeadImpactBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.VehicleDesign.HeadImpactBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.VehicleDesign.HeadImpactBuilder.RequirementsControlType = Object.freeze({
    "StandardDriven" : "StandardDriven", "UserDefined" : "UserDefined"});

SPLM.Features.VehicleDesign.HeadImpactBuilder.CalculationType = Object.freeze({
    "BothSides" : "BothSides", "RightSide" : "RightSide", "LeftSide" : "LeftSide"});

SPLM.Features.VehicleDesign.HeadImpactBuilder.ApproachAngleType = Object.freeze({
    "Mid" : "Mid", "Max" : "Max", "Min" : "Min"});

export default SPLM;